import React from "react"

import GroupBy from "../../../../../../gd/manager/group-by/group-by-model"
import DateGrouping_getGroupLabel from "../../../../../system/task/date/functions/get-group-label"

// const debug = "FieldSelectGroupField_FormValueNotEmpty"
const debug = false

export default function FieldSelectGroupField_FormValueNotEmpty(props:any) {

    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form no-wrap h-36", props.className)

    const groupBy: GroupBy = props.value

    const placeholder = props.field.noValueOption ? props.field.noValueOptionLabel : props.field.placeholder
    const label = !groupBy.field ? placeholder : DateGrouping_getGroupLabel(groupBy)

    const iconClasses = Classes('ui5-ico-15 m-r-8', groupBy.field?.icon)

    debug && console.log(debug, 'render', label, groupBy)

    return (
        <>
            <div className={valueClasses} onClick={props.onClick}>
                {groupBy.field?.icon && <div className={iconClasses}/>}
                <span className="txt-truncate">{label}</span>
            </div>
            {props.children}
        </>
    )
}
